import { useQuery } from 'react-query';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { validationsApi } from 'services/api';

const HOUR = 60 * 60 * 1000;

export const useSpendingLimitOptions = () => {
    const { accountId } = useAccount();
    const { data: hasMaxSpendingLimit } = useQuery(
        ['accountHasMaxSpendingLimit', accountId],
        () => validationsApi.hasMaxSpendingLimit(accountId),
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            cacheTime: HOUR,
            staleTime: HOUR,
        }
    );

    const isNoneSpendingLimitDisplayed = !hasMaxSpendingLimit;
    return isNoneSpendingLimitDisplayed;
};
